import { defaultSchema, type Options as SanitizeSchema } from "rehype-sanitize"

/**
 * 聊天消息里用户 / 机器人内容的 HTML 白名单（在 rehype-raw 之后使用）。
 * 机器人问候语、AI 回复都可能夹带原始 HTML：曾有人用 <iframe srcdoc="<script>"> 在主站同源执行脚本，
 * 而登录态在 localStorage / 非 HttpOnly cookie 里，可被直接读走。
 * 只保留排版类标签；脚本、样式、内嵌页面和音视频连同内容一起删掉，不保留 style / on* 属性。
 * 图片不分来源一律不渲染（目前没有图片审核）；聊天里的正规图片走消息的 image_url 字段，不在正文里。
 */
const STRIP_TAGS = ["script", "style", "iframe", "frame", "frameset", "object", "embed", "video", "audio", "noscript", "template", "svg", "math"]
const MEDIA_TAGS = new Set(["img", "picture", "source"])

export const safeHtmlSchema: SanitizeSchema = {
  ...defaultSchema,
  tagNames: [
    ...(defaultSchema.tagNames ?? []).filter((tag) => !MEDIA_TAGS.has(tag)),
    "center",
    "font",
    "u",
    "mark",
  ],
  attributes: {
    ...defaultSchema.attributes,
    // remark-math 产出的 math-inline / math-display 要留给 rehype-katex 识别
    code: [["className", /^language-./, "math-inline", "math-display"]],
  },
  strip: STRIP_TAGS,
}

type HastNode = {
  type: string
  tagName?: string
  children?: HastNode[]
}

function dropImages(node: HastNode) {
  if (!node.children) return
  node.children = node.children.filter((child) => {
    if (child.type === "element" && child.tagName === "img") return false
    dropImages(child)
    return true
  })
}

/** rehype 插件：去掉 Markdown 图片（![](url)），用于不启用 rehype-raw 的机器人资料渲染 */
export function rehypeStripImages() {
  return (tree: HastNode) => {
    dropImages(tree)
  }
}
